import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

import * as warningsGql from '../../../../../warnings/gql'

const DOC = gql`
  query SpaceRecordWarnings(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $spaceRecordId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                spaceRecordWarnings(spaceRecordId: $spaceRecordId) {
                  code
                  message
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.SpaceRecordWarningsQuery,
    ents.extra.space.Warning[] | undefined,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'space',
              graphql.transformers.OUT.select(
                'spaceRecordWarnings',
                graphql.transformers.OUT.list(
                  graphql.transformers.OUT.object({
                    code: warningsGql.enums.warningCode.TRANSFORMER,
                    message: transformers.PASS_THROUGH,
                  }),
                  { onNullish: 'remove' },
                ),
              ),
            ),
          ),
        ),
      ),
    ),
  ),
  [],
)

export const executor = graphql.createExecutor<
  graphql.schema.SpaceRecordWarningsQuery,
  ents.extra.space.Warning[],
  graphql.schema.SpaceRecordWarningsQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
